import { Util } from "../../../services";
/**
 * Field level validation functions
 */

export var required = function required(value) {
  return value || typeof value === "number" ? undefined : "Required.";
};
var URL_REGEX = new RegExp("^" + // protocol identifier (optional)
"(?:(?:https?|ftp)://)?" + // user:pass authentication
"(?:\\S+(?::\\S*)?@)?" + "(?:" + // IP address exclusion
// private & local networks
"(?!(?:10|127)(?:\\.\\d{1,3}){3})" + "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" + "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" + // IP address dotted notation octets
// excludes loopback network 0.0.0.0
// excludes reserved space >= 224.0.0.0
// excludes network & broacast addresses
// (first & last IP address of each class)
"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" + "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" + "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" + "|" + // host name
"(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" + // domain name
"(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" + // TLD identifier
"(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" + ")" + // port number
"(?::\\d{2,5})?" + // resource path
"(?:/\\S*)?" + "$", "i");
/**
 * Domain level restriction/validation
 * Defined in a 'Restriction/Validation' Airtable column
 */

var dunsNumber = function dunsNumber(value) {
  return value.match(/^[0-9]{9}$/) ? undefined : "Invalid D-U-N-S® number";
};

var max300Chars = function max300Chars(value) {
  return value.length <= 300 ? undefined : "Maximum 300 characters";
};

var _maxNChars = function maxNChars(n) {
  return function (value) {
    return value.length <= n ? undefined : "Maximum ".concat(n, " characters");
  };
};

var brazilianPostalCode = function brazilianPostalCode(value) {
  var pureValues = Util.getPurePostalCodeBra(value);
  return pureValues.match(/^[0-9]{8}$/) ? undefined : "Invalid postal code for Brazil";
};

var cpfTaxId = function cpfTaxId(value) {
  return value.match(/^[0-9]{11}$/) ? undefined : "Invalid CPF code";
};

var rucTaxId = function rucTaxId(value) {
  return value.match(/^[0-9]{11}$/) ? undefined : "Invalid RUC code";
};

var email = function email(value) {
  return value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? undefined : "Invalid email";
};

var url = function url(value) {
  return value.match(URL_REGEX) ? undefined : "Invalid url";
};

var COI_float = function COI_float(value) {
  return Util.countDecimals(value) <= 2 ? undefined : "Format with 2 decimal places expected. e.g. x.yy";
};

var COI_range = function COI_range(value) {
  return Util.checkCOIrange(value) ? undefined : "Range from 0 to 100";
};

var COI_year = function COI_year(value) {
  return value.toString().length === 4 ? undefined : "4 digits expected.";
};

var cnpjTaxId = function cnpjTaxId() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var stripped = value.replace(/[-\/.]/g, "");
  return stripped && stripped.length === 14 ? undefined : "Invalid CNPJ code";
};

var createNonEmptyValueRestriction = function createNonEmptyValueRestriction(validateFn) {
  return function (value) {
    if (!value) {
      return;
    }

    return validateFn(value);
  };
};
/**
 * Util functions for validations
 */


var availableValidations = {
  required: required,
  "DUNS number": createNonEmptyValueRestriction(dunsNumber),
  "max 300 chars": createNonEmptyValueRestriction(max300Chars),
  maxNChars: function maxNChars(n) {
    return createNonEmptyValueRestriction(_maxNChars(n));
  },
  "Postal Code": createNonEmptyValueRestriction(brazilianPostalCode),
  "CNPJ tax ID": createNonEmptyValueRestriction(cnpjTaxId),
  "CPF tax ID": createNonEmptyValueRestriction(cpfTaxId),
  "RUC tax ID": createNonEmptyValueRestriction(rucTaxId),
  email: createNonEmptyValueRestriction(email),
  url: createNonEmptyValueRestriction(url),
  COI_float: createNonEmptyValueRestriction(COI_float),
  COI_range: createNonEmptyValueRestriction(COI_range),
  COI_year: createNonEmptyValueRestriction(COI_year)
};
export var getAllValidationsInArray = function getAllValidationsInArray(validations) {
  return validations.reduce(function (validationsArray, validation) {
    var validationFn = null;

    if (validation.validationName.indexOf("maxNChars") > -1) {
      var maxChars = validation.validationName.split("(")[1].slice(0, -1);
      validationFn = availableValidations["maxNChars"](maxChars);
    } else {
      validationFn = availableValidations[validation.validationName];
    }

    if (validationFn) {
      validationsArray.push(validationFn);
    }

    return validationsArray;
  }, []);
};